/**
 * WebAuthnBridge — `navigator.credentials.create/get` の seam
 *
 * `@simplewebauthn/browser` v11 (`startRegistration` / `startAuthentication`) に委譲する。
 * これらは optionsJSON (base64url) を native (ArrayBuffer) に変換して
 * `navigator.credentials.create/get` を呼び、サーバの verify が期待する
 * `RegistrationResponseJSON` / `AuthenticationResponseJSON` を返す。
 *
 * server 側 (`@simplewebauthn/server` v11) と format を揃えるため SimpleWebAuthn を使用。
 * このモジュールは injectable な seam で、task 11.4 が stub に差し替える。
 */
import { startAuthentication, startRegistration } from "@simplewebauthn/browser";
/**
 * SimpleWebAuthn-backed の `WebAuthnBridge` を生成する。
 */
export function createWebAuthnBridge() {
    return {
        create(optionsJSON) {
            return startRegistration({ optionsJSON });
        },
        get(optionsJSON, mediation) {
            // Conditional UI (autofill) は `mediation: "conditional"` 指定時のみ有効化。
            return startAuthentication({
                optionsJSON,
                useBrowserAutofill: mediation === "conditional",
            });
        },
    };
}
//# sourceMappingURL=webauthn-bridge.js.map